/* 复刻页交互脚本: 仅在含 #ls-replica 的页面加载 (对标 site.js 的轮播/滑动逻辑) */
(() => {
  'use strict';
  const initReplica = () => {
  const scope = document.querySelector('#ls-replica');
  if (!scope) return;
// Keep the rendered desktop carousel state while making arrow controls useful
  // in a local snapshot without loading jQuery or the reference site's plugins.
  const tracks = Array.from(scope.querySelectorAll('.slick-track'));
  const moveTrack = (track, direction) => {
    const list = track.parentElement;
    const slides = Array.from(track.querySelectorAll('.slick-slide:not(.slick-cloned)'));
    if (!list || !slides.length) return;
    const current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('slick-current')));
    const next = (current + direction + slides.length) % slides.length;
    const width = list.clientWidth / Math.max(1, window.innerWidth < 760 ? 1 : window.innerWidth < 1100 ? 3 : 4);
    slides.forEach((slide, index) => {
      slide.style.width = `${width}px`;
      slide.classList.toggle('slick-current', index === next);
      slide.classList.toggle('slick-active', Math.abs(index - next) < (window.innerWidth < 760 ? 1 : 4));
    });
    track.style.width = `${width * (slides.length + 8)}px`;
    track.style.transform = `translate3d(${-width * Math.max(0, next)}px, 0, 0)`;
  };
  /* 20261016 baked slick transform-only navigation: baked slick carousels (captured pages) ship
     clone slides and a transform that already accounts for leading clones. The generic moveTrack
     resizes slides and shrinks track.width below the floated total, wrapping slides onto a second
     row, and its index math ignores leading clones. Navigate those by transform steps only,
     clamped so the last row of real cards is the end of the range; simple upgrade carousels keep
     moveTrack. */
  scope.querySelectorAll('.slick-prev, .slick-next').forEach((button) => {
    button.addEventListener('click', () => {
      const host = button.closest('.slick-slider') || button.closest('.product-carousel-wrapper');
      const track = host ? host.querySelector('.slick-track') : tracks[0];
      if (!track) return;
      if (!track.querySelector('.slick-cloned')) {
        moveTrack(track, button.classList.contains('slick-next') ? 1 : -1);
        return;
      }
      const list = track.parentElement;
      const slideW = Math.round(track.children[0].getBoundingClientRect().width) || 320;
      const visible = Math.max(1, Math.round(list.clientWidth / slideW));
      const realSlides = track.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
      const leadingClones = Math.max(0, Array.prototype.findIndex.call(
        track.children, (slide) => !slide.classList.contains('slick-cloned')));
      const maxPos = Math.max(0, leadingClones + realSlides - visible);
      const current = Math.round(
        -(parseFloat((track.style.transform.match(/translate3d\((-?[\d.]+)px/) || [])[1]) || 0) / slideW
      );
      const next = Math.min(
        Math.max(current + (button.classList.contains('slick-next') ? 1 : -1), 0),
        maxPos
      );
      track.style.transform = `translate3d(${-next * slideW}px, 0px, 0px)`;
    });
  });
  scope.querySelectorAll('.reviews-prev, .reviews-next').forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.closest('.reviews-carousel')?.querySelector('.embla__container');
      if (!container) return;
      const slides = Array.from(container.children);
      const current = Number(container.dataset.slide || 0);
      const next = (current + (button.classList.contains('reviews-next') ? 1 : -1) + slides.length) % slides.length;
      container.dataset.slide = String(next);
      container.style.transform = `translate3d(${-next * 100}%, 0, 0)`;
    });
  });

  // Carousels captured before slick initialized get rebuilt here so they render
  // and animate like the initialized ones: one row of slides, SVG arrow controls
  // and an auto-advance that pauses while hovered.
  const perViewFor = () => (window.innerWidth < 560 ? 1 : window.innerWidth < 760 ? 2 : window.innerWidth < 1100 ? 3 : 4);
  scope.querySelectorAll('.product-carousel:not(.slick-initialized)').forEach((carousel) => {
    if (carousel.dataset.upgraded) return;
    const slides = Array.from(carousel.children).filter((el) => el.tagName === 'DIV');
    if (!slides.length) return;
    carousel.dataset.upgraded = '1';
    const list = document.createElement('div');
    list.className = 'slick-list';
    const track = document.createElement('div');
    track.className = 'slick-track';
    track.style.transition = 'transform 0.45s ease';
    slides.forEach((slide) => { slide.classList.add('slick-slide'); track.appendChild(slide); });
    list.appendChild(track);
    carousel.classList.add('slick-initialized', 'slick-slider');
    carousel.appendChild(list);

    const wrapper = carousel.closest('.product-carousel-wrapper') || carousel.parentElement;
    // Fewer slides than one full row: nothing to scroll, no arrows or autoplay.
    const scrollable = slides.length > perViewFor();
    const makeArrow = (className, label, flip) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `${className} slick-arrow`;
      button.setAttribute('aria-label', label);
      button.innerHTML = `<svg fill="none" height="16"${flip ? ' style="transform: rotate(180deg);"' : ''} viewbox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M0 16V14H12.59L0.00016276 1.41L1.41016 0L14 12.59V0H16V16H0Z" fill="#FFFFFF"></path></svg>`;
      return button;
    };
    const prev = makeArrow('slick-prev', 'Previous slide', true);
    const next = makeArrow('slick-next', 'Next slide', false);
    if (scrollable) { wrapper.appendChild(prev); wrapper.appendChild(next); }

    let index = 0;
    const bounds = () => {
      const per = perViewFor();
      const width = (list.clientWidth || carousel.clientWidth) / per;
      return { per, width, maxIndex: Math.max(0, slides.length - per) };
    };
    const apply = () => {
      const { width, maxIndex } = bounds();
      index = Math.min(index, maxIndex);
      slides.forEach((slide) => { slide.style.width = `${width}px`; });
      track.style.width = `${width * slides.length}px`;
      track.style.transform = `translate3d(${-index * width}px, 0, 0)`;
    };
    const step = (direction) => {
      const { maxIndex } = bounds();
      index = index + direction > maxIndex ? 0 : index + direction < 0 ? maxIndex : index + direction;
      apply();
    };
    let timer = null;
    const stop = () => { if (timer) { window.clearInterval(timer); timer = null; } };
    const start = () => { if (!timer) timer = window.setInterval(() => step(1), 4000); };
    prev.addEventListener('click', () => { step(-1); stop(); start(); });
    next.addEventListener('click', () => { step(1); stop(); start(); });
    wrapper.addEventListener('mouseenter', stop);
    wrapper.addEventListener('mouseleave', start);
    window.addEventListener('resize', apply);
    apply();
    if (scrollable) start();
  });

  scope.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"], button');
      if (!button) return;
      const original = button.textContent;
      button.textContent = 'Saved for preview';
      window.setTimeout(() => { button.textContent = original; }, 1800);
    });
  });


  // 表单提交占位（预览环境无后端处理）
  scope.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"], button');
      if (!button) return;
      const original = button.textContent;
      button.textContent = 'Saved for preview';
      window.setTimeout(() => { button.textContent = original; }, 1800);
    });
  });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReplica);
  } else {
    initReplica();
  }
})();

  // ===== define-look 选项切换（section-define-look：点击选项联动右侧图片与文字） =====
  document.querySelectorAll('.section-define-look').forEach((section) => {
    const options = Array.from(section.querySelectorAll('.define-option'));
    if (!options.length) return;
    const image = section.querySelector('.define-look-image img');
    const textInner = section.querySelector('.define-look-text-inner');
    const toCdn = (url) => {
      if (!url || /^https?:/.test(url)) return url;
      const name = url.split('/').pop();
      return 'https://cdn.shopify.com/s/files/1/0701/5153/6717/files/' + name;
    };
    const apply = (opt) => {
      options.forEach((o) => {
        o.classList.toggle('active', o === opt);
        if (o !== opt) o.removeAttribute('open');
      });
      opt.setAttribute('open', '');
      if (image && opt.dataset.image) image.src = toCdn(opt.dataset.image);
      if (textInner) {
        const hidden = opt.querySelector('.hidden-content');
        const title = opt.dataset.title || (opt.querySelector('summary') ? opt.querySelector('summary').textContent.trim() : '');
        textInner.innerHTML =
          '<h3 id="define-title">' + title + '</h3>' +
          '<div id="define-description">' + (hidden ? hidden.innerHTML : '') + '</div>';
      }
    };
    options.forEach((opt) => {
      opt.addEventListener('toggle', () => { if (opt.open) apply(opt); });
    });
    const initial = options.find((o) => o.open || o.classList.contains('active')) || options[0];
    if (initial) apply(initial);
  });


/* 20261016 accordion-video wiring: page content ships data-video-url per FAQ question, but nothing consumed it —
   clicking a question only toggled native <details> and the right panel stayed a static still.
   Wire it up: one question open at a time; on open, activate it and load its YouTube video
   into .accordion-video .video-embed. The static poster stays until the first click (no
   autoplay on page load). */
(function () {
  document.querySelectorAll('.component-accordion-video').forEach(function (section) {
    if (section.dataset.lsAccordionVideoWired) return;
    section.dataset.lsAccordionVideoWired = '1';
    var embed = section.querySelector('.accordion-video .video-embed');
    if (!embed) return;
    var items = Array.prototype.slice.call(section.querySelectorAll('.accordion-details'));
    var loadVideo = function (item) {
      var url = item.getAttribute('data-video-url');
      if (!url) return;
      /* 20261016: accept /embed/ID, youtu.be/ID and watch?v=ID - a raw youtu.be/watch URL
         in an iframe renders blank because YouTube refuses to frame non-embed URLs. */
      var idMatch = url.match(/embed\/([A-Za-z0-9_-]+)/) || url.match(/youtu\.be\/([A-Za-z0-9_-]+)/) || url.match(/[?&]v=([A-Za-z0-9_-]+)/);
      var src = 'https://www.youtube.com/embed/' + (idMatch ? idMatch[1] : url) + '?autoplay=1&rel=0';
      var summary = item.querySelector('summary');
      var label = summary ? summary.textContent.trim().replace(/"/g, '&quot;') : 'Longshade video';
      embed.innerHTML =
        '<div class="video-responsive"><iframe src="' + src +
        '" title="' + label +
        '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe></div>';
    };
    items.forEach(function (item) {
      if (item.dataset.lsAccordionBound) return;
      item.dataset.lsAccordionBound = '1';
      item.addEventListener('toggle', function () {
        if (!item.open) {
          // clicking the active (open) question means "play this one": keep it open and load
          // its video; the forced reopen fires toggle again and runs the open branch below.
          if (item.classList.contains('active')) item.open = true;
          return;
        }
        items.forEach(function (other) {
          if (other !== item) other.classList.remove('active');
        });
        item.classList.add('active');
        loadVideo(item);
      });
    });
  });
})();
/* 20261016 zingas comparison slider wiring v2 (smooth drag): the captured pages ship the
   masking-engine CSS but no script consumed it. v1 wired basic pointer drag; v2 makes it
   smooth: whole wrapper is the drag surface (press anywhere, not only the 38px button),
   transitions are disabled on mask/line/button while interacting (their CSS transition:all
   made the visuals lag behind the pointer), moves are coalesced with requestAnimationFrame,
   and native image drag / text selection are suppressed. Works for is-vertical and
   is-horizontal variants. NOTE: ls-replica.js gets rebuilt from source by the other
   workstream - carry this block over when rebuilding. */
(function () {
  var wire = function (wrapper) {
    if (wrapper.dataset.lsZingasWired === '2') return;
    var mask = wrapper.querySelector('.zingas-img-before-mask');
    var button = wrapper.querySelector('.zingas-drag-button');
    var line = wrapper.querySelector('.zingas-split-line');
    if (!mask || !button) return;
    wrapper.dataset.lsZingasWired = '2';
    var vertical = wrapper.classList.contains('is-vertical');
    [mask, button, line].forEach(function (el) { if (el) el.style.transition = 'none'; });
    wrapper.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
    wrapper.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var rect = null, pendingFrame = 0, lastX = 0, lastY = 0;
    var apply = function () {
      if (!rect) return;
      var pct = vertical
        ? ((lastY - rect.top) / rect.height) * 100
        : ((lastX - rect.left) / rect.width) * 100;
      pct = Math.min(100, Math.max(0, pct));
      if (vertical) {
        mask.style.height = pct + '%';
        if (line) line.style.top = pct + '%';
        button.style.top = pct + '%';
      } else {
        mask.style.width = pct + '%';
        if (line) line.style.left = pct + '%';
        button.style.left = pct + '%';
      }
    };
    var queue = function (e) {
      lastX = e.clientX; lastY = e.clientY;
      rect = wrapper.getBoundingClientRect();
      if (!pendingFrame) pendingFrame = requestAnimationFrame(function () { pendingFrame = 0; apply(); });
    };
    var stop = function () { wrapper.dataset.lsZingasDragging = '0'; };
    wrapper.style.touchAction = 'none';
    wrapper.addEventListener('pointerdown', function (e) {
      wrapper.dataset.lsZingasDragging = '1';
      if (wrapper.setPointerCapture) { try { wrapper.setPointerCapture(e.pointerId); } catch (err) {} }
      e.preventDefault();
      queue(e);
    });
    wrapper.addEventListener('pointermove', function (e) {
      if (wrapper.dataset.lsZingasDragging === '1') queue(e);
    });
    wrapper.addEventListener('pointerup', stop);
    wrapper.addEventListener('pointercancel', stop);
    wrapper.addEventListener('lostpointercapture', stop);
  };
  var scan = function () {
    document.querySelectorAll('[data-zingas-slider]').forEach(wire);
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
})();
